<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <DatePickerRange title="抵扣时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons  type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons  type="success" icon="Plus" @click="checkDetail(-1)"> 添加 </ElButtons>
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="时间" width="200"/>
      <el-table-column property="preBookNumberNo" label="消费单号" width="140"/>
<!--      <el-table-column property="content" label="充值记录"/>-->
      <el-table-column property="content" label="抵扣记录" />
      <el-table-column property="adminName" label="添加人" width="120"/>
      <el-table-column property="relationAdminName" label="操作" width="120">
        <template #default="scope">
          <el-button type="primary" size="small" @click="checkDetail(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getAllShopList, pageDeductionList, getRecordShops, getUserInfo} from '@/api/url';
// import Dialog from '@/assets/js/dialog'
// import AddUserRemarkDialog from './AddUserRemarkDialog';
import SearchComponents from "@/components/SearchComponents";
import DatePickerRange from "@/components/DatePickerRange";
import Dialog from "@/assets/js/dialog";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      userForm: this.value.userForm,
      pageType: this.value.pageType,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '消费单号', value : 1},
        {label : '添加人', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      balanceType: -1,
      balanceTypeArray: [
        {label: '不限', value: -1},
        {label: '500账户', value: 1},
        {label: '1000账户', value: 2},
        {label: '1500账户', value: 3},
        {label: '2500账户', value: 4}
      ],

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.id;
      // param['balanceType'] = this.balanceType;
      // param['pageType'] = this.pageType;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(pageDeductionList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          if(this.pageDataList.length > 3) {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList.slice(0,3)));
          } else {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList));
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getShopList() {
      let param = {}
      param['userId'] = this.id
      param['type'] = 3
      getFormData(getRecordShops, param).then(data=> {
        data.data.map((item) => {
          this.shopIdArr.push(item)
        })
        this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
      })
    },

    checkDetail(idx, row) {
      // getFormData(getUserInfo, {id: this.userForm.id}).then(data => {
      //
      // })

      let consumeForm = {}
      let consumeId = 0
      if(idx > -1) {
        consumeForm = Object.assign({}, row);
        consumeId = consumeForm.preBookId
      }
      Dialog.open({
        title: '',
        component: ConsumeDetailDialog,
        data: {
          userForm: this.userForm,
          consumeId: consumeId,
          idx: idx
        },
        confirm: (result) => {
          this.getPage();
          this.getUserInfo()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })

    },

    getUserInfo() {
      let param = {};
      param['id'] = this.id;
      getFormData(getUserInfo, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.userForm = data.data
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(()=> {
      })
    },

  },
  mounted() {
    // this.getShopList()
    this.getPage();
    this.getUserInfo()
  }
}
</script>

<style>

</style>
